import { Theme } from '@mui/material'

const useStyles = {
  headerAppBar: (theme: Theme) => ({
    backgroundColor: theme.palette.ui.main,
    zIndex: theme.zIndex.drawer + 1, // Higher than contact cards (drawer zIndex)
  }),
  headerAppBarWithBorder: (theme: Theme) => ({
    borderBottom: `1px solid ${theme.palette.divider}`,
  }),
  headerAppBarDark: (theme: Theme) => ({
    backgroundColor: theme.palette.ui.primary50,
    borderBottom: 0,
  }),
  headerAppBarContainer: (theme: Theme, showBorderBottom: boolean, useDarkBackground: boolean, isShortScreen: boolean, dashboardTab?: string) => ({
    ...useStyles.headerAppBar(theme),
    ...(showBorderBottom ? useStyles.headerAppBarWithBorder(theme) : {}),
    ...(useDarkBackground ? useStyles.headerAppBarDark(theme) : {}),
    ...(isShortScreen && !dashboardTab ? { paddingTop: 0 } : {}),
  }),
  headerToolbar: () => ({
    width: '100%',
  }),
  headerToolbarCentered: (theme: Theme) => ({
    [theme.breakpoints.up('sm')]: {
      margin: '0 auto',
    },
  }),
  headerToolbarMobileStart: {
    justifyContent: 'flex-start',
  },
  headerToolbarMobileCentered: {
    justifyContent: 'center',
  },
  hamburgerButton: {
    mr: 1,
  },
  headerActions: {
    alignItems: 'center',
    justifyContent: 'flex-end',
    flex: 1,
    gap: 1,
  },
  logo: {
    height: '35px',
    display: 'block',
  },
  userButton: (theme: Theme, useDarkBackground: boolean, showCompactUserMenu: boolean | undefined) => ({
    textTransform: 'none',
    gap: '4px',
    whiteSpace: 'nowrap',
    paddingLeft: showCompactUserMenu ? theme.spacing(1) : theme.spacing(3),
    paddingRight: showCompactUserMenu ? theme.spacing(1) : theme.spacing(3),
    ...(showCompactUserMenu && {
      minWidth: '40px',
      '& .MuiButton-startIcon': {
        margin: 0,
      },
    }),
    '&.MuiButtonBase-root': {
      color: useDarkBackground ? theme.palette.common.white : theme.palette.text.secondary,
    },
  }),
  downloadAppButton: {
    textTransform: 'none',
    whiteSpace: 'nowrap',
    gap: 0.5,
  },
  userAvatar: (theme: Theme) => ({
    width: 24,
    height: 24,
    bgcolor: theme.palette.primary.light,
    color: theme.palette.primary.main,
    '&.MuiAvatar-root': {
      fontSize: '1rem',
    },
  }),
  menuList: {
    minWidth: '200px',
  },
  pageTitle: (useDarkBackground: boolean, theme: Theme) => ({
    textAlign: 'center',
    width: '100%',
    color: useDarkBackground ? theme.palette.common.white : 'inherit',
  }),
  spacer: {
    width: '24px',
  },
  iconSpacer: {
    width: '40px',
  },
}

export default useStyles
